import iSpiroPopupComponent from './iSpiroPopup.component';

const iSpiroPopupModule = angular.module('app.components.clinicalData.subjects.iSpiroPopup', [])
	.component('iSpiroPopup', iSpiroPopupComponent)
	.name;

export default iSpiroPopupModule;
